<template>
  <v-container class="no-margins">
    <h1>{{ $t('application.company.title') }}</h1>

    <p>{{ $t('application.company.info2') }}</p>
    <p>{{ $t('application.company.info3') }}</p>

    <!-- Form with company number input field -->
    <v-form v-model="valid" ref="form" class="mt-10">
      <v-text-field
        v-shortkey="['enter']"
        @shortkey.native="nada()"
        outlined
        label="Organisationsnummer"
        v-model="model"
        v-mask="mask"
        :loading="isLoading"
        placeholder="nnnnnn-nnnn"
        :rules="[rules.required, rules.orgnr]"
        v-on:keyup.enter="nextStep"
        required
      ></v-text-field>
    </v-form>
    <!-- Display company data if there is an company as result-->
    <v-expand-transition v-if="validCompany">
      <v-card flat elevation="0">
        <v-list class="box-shadow">
          <v-list-item v-if="company" v-model="checkRadio" class="height-large">
            <v-list-item-content>
              <v-list-item-title v-html="company.name"></v-list-item-title>
              <v-list-item-subtitle>{{ company.postalCity }}, {{ company.organizationalNumber | formatOrgNo }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <div class="v-list-item__radio">
                <input type="radio" v-model="checkRadio" :value="checkRadio" />
                <div class="check">
                  <div class="inside"></div>
                </div>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-expand-transition>
    <!-- Display erorr message if there is no company for that organization number-->
    <v-expand-transition v-if="showMsg || isNewCompany">
      <MessageBox class="my-5" type="info">
        <p v-html="$t('application.company.missinginfo1')"></p>        
      </MessageBox>
    </v-expand-transition>

    <!-- Enable button if the company is found and go to the next step-->

    <NextButton v-if="hasDeps == true" :isDisabled="!validCompany" class="mt-6" @click="nextStep">{{
      $t('application.company.department-title-next-step')
    }}</NextButton>
    <NextButton v-else :isDisabled="!validCompany" class="mt-6" @click="nextStep">{{ $t('tour.next') }}</NextButton>

    <div v-if="loGet(selectedApplication, 'showDocuments')">
      <BottomNav @clicked="$emit('goToStep', '-1')"></BottomNav>
    </div>
    <div v-else><BottomNav @clicked="$emit('goToStep', `${selectedApplication.transferOldProfession ? '3' : '-2'}`)"></BottomNav></div>
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import {mask} from 'vue-the-mask'
import {RulesMixin} from '@/components/mixins'
import BottomNav from '@/components/Application/BottomNav'
import MessageBox from '@/components/Common/MessageBox.vue'
import NextButton from '@/components/Common/NextButton'
import get from 'lodash/get'

// @group Application-Apprentice
// ApplicationCompanies component
export default {
  name: 'ApplicationCompanies',

  mixins: [RulesMixin],
  components: {
    BottomNav,
    MessageBox,
    NextButton
  },

  directives: {
    mask
  },

  data: () => ({
    mask: '######-####',
    company: null,
    model: '',
    valid: false,
    checkRadio: true,
    isLoading: false,
    dissBtn: true,
    showMsg: false,
    orgNumber: '',
    lastCompanyId: -1,
    orgNoDashNumber: null,
    requestCompanyApproval: false
  }),

  // @vuese
  // Watch the search input in autocomplete and call the querySelections function
  // @arg The argument is a string  value representing {search: value}

  watch: {
    /**
     * @vuese
     * Used to watch the company org number and fetch teh company based on org value
     * @arg The argument is an integer value representing company organization number
     */
    model(val) {
      this.orgNumber = val
      this.showMsg = false
      
      this.$nextTick(() => {
        if ( val.length === 11 && this.$route.query?.step == 7 )
          this.getCompany()
      })
    },

    /**
     * @vuese
     * Used to watch the selectedApplication and fetch the company
     * @arg The argument is an integer value representing company id
     */
    selectedApplication: {
      handler: function () {
        if (this.selectedApplication && this.selectedApplication.companyId) {
          this.getCompanyById(this.selectedApplication.companyId)
        }
      },
      deep: true
    },

    /**
     * @vuese
     * Used to watch the currentStep and fetch the company
     * @arg The argument is an integer value representing company id
     */
    currentStep: {
      handler: function () {
        if (this.selectedApplication && this.selectedApplication.companyId) {
          this.getCompanyById(this.selectedApplication.companyId)
        }
      },
      deep: true
    }
  },
  created() {
    /**
     * @vuese
     * Used to  fetch the company once component is create if the company id exist
     * @arg The argument is an integer value representing company id
     */
    if (this.selectedApplication && this.selectedApplication.companyId) {
      this.getCompanyById(this.selectedApplication.companyId)
    }
  },
  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('basic', ['hasProfessionOrientations']),

    isNewCompany(){
      return this.company && !this.company.id
    },

    hasDeps(){
      return this.company && !!this.company.hasDepartments
    },

    validCompany(){
      return !!this.company && this.valid
    }
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),

    /**
     * @vuese
     * Used fetch the company by id
     * @arg The argument is an integer value representing company id
     */
    getCompanyById(id) {
      API.getCompany(id)
        .then(res => {
          if (res.data && res.data.organizationalNumber.length == 10) {
            this.dissBtn = false
            this.showMsg = false
            this.company = res.data
            this.orgNumber =
              res.data.organizationalNumber.substring(0, 6) + '-' + res.data.organizationalNumber.substring(6, 10)
            this.model = this.orgNumber
            // not empty
          } else {
            this.dissBtn = true
            this.showMsg = true
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    /**
     * @vuese
     * Used fetch the company by org number
     * @arg The argument is an integer value representing org number
     */
    getCompany() {
      
      this.dissBtn = true

      if (!this.orgNumber || this.orgNumber === '') {
        this.showMsg = false
        return
      }

      if (!this.$refs.form.validate()) {
        this.isLoading = false
        this.showMsg = false
        return
      }

      this.isLoading = true

      this.orgNoDashNumber = this.orgNumber.split('-').join('')

      API.getCompanyByNumber(this.orgNoDashNumber)
        .then((res) => {
          if ( this.companyIsWithoutAgreement(get(res, 'data.agreement', null) ) || 
          this.apprenticeshipAgreementType(get(res, 'data.agreement', 0)) )
            return this.showAgreementInfo(res.data)

          this.showMsg = false
          this.company = res.data
          this.requestCompanyApproval = false
        })
        .catch((err) => {
          this.company = null
          this.showMsg = true
          this.requestCompanyApproval = true
        })
        .finally(() => {
          this.isLoading = false
          this.dissBtn = false
        })
    },

    showAgreementInfo (company) {
      let title = this.$t('application.company.missing-agreement-heading')
      let text = this.$t('application.company.missing-agreement-text', { companyName: get(company, 'name', '') })

      if ( this.apprenticeshipAgreementType(get(company, 'agreement', 0)) ) {
        title = this.$t('application.company.apprenticeship-agreement.title')
        text = this.$t('application.company.apprenticeship-agreement.text', { company: company.name })
      }

      return this.$dialog.confirm({
        title,
        text,
        actions: [
          { text: this.$t('labels.close'), key: true, icon: '$sl-close' }
        ]
      })
      .then(() => {
        if ( !this.apprenticeshipAgreementType(get(company, 'agreement', 0)) ) {
          this.company = null
          this.dissBtn = true
        } else {
          this.company = company
        }
      })
    },

    /*  // 
    // Used to update the db and move to the new step
    //  The argument is a int  value representing of the current application
    clickBack() {
      if (this.orgNumber && this.orgNumber != this.model) {
        this.model = this.orgNumber
      }
      this.$emit('goToStep', '-1')
    }, */

    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias
     * @arg The argument is an integer value representing company id
     */
    nextStep() {
      if (!this.valid) {
        this.isLoading = true
        return
      }
      if (this.company && this.lastCompanyId == this.company.id) {
        // Fire +1 if company id is not changed and go to next step
        // @arg The argument is a integer representing (move one step forward)
        if (this.hasDeps == true) this.$emit('goToStep', '+1')
        else this.$emit('goToStep', '+2')
      } else if (this.selectedApplication.id && this.selectedApplication.id > 0) {
        // - Used to check if the apprentice has requested to register new  company that dont  exist in db

        let params = {};
        if(this.requestCompanyApproval){
          params = {
              data: {
                organizationalNumber: this.orgNoDashNumber,
                step: this.currentStep
              },
            requestCompanyApproval: true
          }
        } else if(!this.company.id){
          params = { 
            data: { step: this.currentStep },
            company: this.company
          }
        } else {
          params = { data: { companyId: this.company.id, step: this.currentStep } }
        }

        console.log(params)
        API.updateApplication(this.selectedApplication.id, params)
          // Used to update the SelectedApplication with the found id
          .then(({data}) => {
            if (this.company !== null) {
              this.company = data.company
              this.lastCompanyId = this.company.id
              /**
               * @vuese
               * Used to store new criterias in vuex store
               * @arg The arguments are companyId ,current step and instructorId
               */
              this.updateSelectedApplication({
                companyId: this.company.id,
                step: this.currentStep,
                instructorId: -1,
                departmentId: -1
              })
              // Fire +1
              // @arg The argument is a integer representing (move one step forward)
              if (this.hasDeps == true) this.$emit('goToStep', '+1')
              else this.$emit('goToStep', '+2')
            }

            if (this.requestCompanyApproval) {
              // Fire last if request company for approval
              // @arg The argument is a string representing end of this application until company is approved
              this.$emit('goToStep', 'last')
            }
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      } else {
        this.$events.fire('showError', this.$t('errors.save-failure'))
      }
    },
    /**
     * @vuese
     * Used to stop the application if any key except Enter is typed
     * @arg is called without argument
     */
    nada() {},

    apprenticeshipAgreementType(agreement) {
      if ( agreement == null ) return
      return agreement == 8
    },

    companyIsWithoutAgreement(contractTypeId) {
      return [10, null, undefined].includes(contractTypeId)
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: none !important;
}
</style>
